import { getCurrentVendor, Vendor } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import * as HiveDownload from './vendor/hive/download.js';
import * as IrisDownload from './vendor/iris/download.js';

/** `<Download>` component. */
export const Download = (): ReactElement => {
  const vendor = getCurrentVendor();

  if (vendor === Vendor.IRIS) {
    return <IrisDownload.Download />;
  }

  return <HiveDownload.Download />;
};
